import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';

class RedirectHandler extends Component {

  static propTypes = {
    impostaUfficioSelezionato: PropTypes.func,
    profilo: PropTypes.any
  }

  getCodiceUfficio() {
    this.props.match.params.codiceUfficio;
  }

  componentDidMount() {
    this.impostaCodiceUfficio(this.getCodiceUfficio());
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next.match.params.codiceUfficio != this.getCodiceUfficio()) {
      this.impostaCodiceUfficio(next.match.params.codiceUfficio);
    }
  }

  impostaCodiceUfficio = ufficio => {
    if (this.props.profilo.Uffici.some(x => x == ufficio)) {
      this.props.impostaUfficioSelezionato(ufficio);
    }

    this.props.history.push("/messaggi/quesiti/aperti");
  }

  render() {
    return <div>{this.getCodiceUfficio()}</div>;
  }
}

RedirectHandler.contextTypes = {
  router: PropTypes.object
};

const mapStateToProps = state => {
  return {
    profilo: state.profilo,
    ufficioSelezionato: state.ufficioSelezionato
  };
};

const mapDispatchToProps = dispatch => {
  return {
    impostaUfficioSelezionato: ufficioSelezionato => dispatch({
      type: 'IMPOSTA_UFFICIO_SELEZIONATO',
      ufficioSelezionato: ufficioSelezionato
    })
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RedirectHandler);